














































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import VideoShow from '@/dex-shared/components/new_content/show/VideoShow.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import pxTooltip from '@/dex-shared/components/px-tooltip.vue';

export default Vue.extend({
  components: {
    VideoShow,
    pxButton,
    PlusIcon,
    pxTooltip,
  },
  props: {
    videoId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      providerId: null,
      name: null,
      duration: null,
      description: null,
      providerType: null,
      isDurationPlusTooltipOpened: false,
      videoAnnotationsTimeline:
        'https://dex-admin-assets.s3.sa-east-1.amazonaws.com/video-annotations-timeline.png',
    };
  },
  computed: {
    ...mapGetters({
      videoById: 'videoById',
    }),
    video() {
      return this.videoById(this.videoId);
    },
    videoContent() {
      return {
        id: this.videoId,
        name: this.name,
        providerId: this.providerId,
        duration: +this.duration ? +this.duration : null,
        description: this.description,
        providerType: this.providerType,
      };
    },
  },
  async created() {
    await this.$store.dispatch('GET_VIDEO_BY_ID', this.videoId);
    this.initizalizeVideoInfo();
    await this.getVideoDuration();
  },
  methods: {
    async updateVideoContent() {
      await this.$store.dispatch('UPDATE_VIDEO_BY_ID', this.videoContent);
      this.$emit('finished');
    },
    changeProviderType(type) {
      this.providerType = type;
    },
    initizalizeVideoInfo() {
      this.providerId = this.video.providerId;
      this.name = this.video.name;
      this.duration = this.video.duration;
      this.description = this.video.description;
      this.providerType = this.video.providerType;
    },
    openDurationPlusTooltip() {
      this.isDurationPlusTooltipOpened = !this.isDurationPlusTooltipOpened;
    },
    async getVideoDuration() {
      if (this.providerType === 'KALTURA') {
        this.duration = await this.$store.dispatch(
          'PULL_KALTURA_VIDEO_DURATION',
          this.providerId,
        );
      }
    },
  },
});
